import React from 'react';
import styled from 'styled-components';
import { fadedGray, textGray } from '../utils/colors';
import ProgressBar from './ProgressBar';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const StyledPartCard = styled(({ active, ...rest }) => <Link {...rest} />)`
  border-radius: 10px;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  min-width: 269px;
  min-height: 500px;
  text-decoration: none;
  color: ${fadedGray};
  margin-left: 1.5rem;
  position: relative;
  transition: transform 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  cursor: pointer;

  &:first-child {
    margin-left: 0;
  }

  @media all and (min-width: 40rem) {
    &:hover {
      transform: translateY(-20px);
      box-shadow: 0 30px 40px -10px rgba(0, 0, 0, 0.4);
    }
  }

  @media all and (max-width: 40rem) {
    min-height: 400px;
  }
`;

const StyledPartImage = styled.img`
  min-height: 200px;
  max-height: 200px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
`;

const StyledPartContent = styled.div`
  padding: 1.5rem;
`;

const StyledPart = styled.span`
  font-size: 0.875rem;
  font-weight: 600;
  margin-bottom: 0;
  text-transform: uppercase;
`;

const StyledName = styled.h2`
  color: ${props => props.theme.tertiary};
  margin: 0.5rem 0;
`;

const OrderedList = styled.ul`
  padding: 0;
  list-style: none;
  margin: 0 0 3rem 0;

  li {
    list-style-type: none;
    font-size: 0.875rem;
    margin: 0.25rem 0;
    font-weight: 300;

    a {
      display: flex;

      span {
        &.chapter-counter {
          margin-right: 0.5rem;
        }
      }
    }
  }
`;

const StyledEstimated = styled.p`
  text-transform: uppercase;
  font-size: 0.875rem;
  font-weight: 600;
  letter-spacing: 0.5px;
  color: ${fadedGray};
  position: absolute;
  bottom: 0.2rem;
  left: 1.5rem;
`;

const StyledHours = styled.span`
  color: ${props => props.theme.tertiary};
  text-transform: lowercase;
`;

const Go = styled(({ ...props }) => <Link {...props} />)`
  color: ${textGray};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const ChapterPartCard = ({
  to,
  gfx,
  part,
  name,
  chapters,
  progress,
  bookId
}) => {
  let progressStarted = false;

  const calcedEstimatedTime = chapters
    .map(item => item.estimatedTime)
    .reduce((a, b) => a + b);

  for (let i = 0; i < chapters.length; i++) {
    if (chapters[i].read) {
      progressStarted = true;
    }
  }

  return (
    <StyledPartCard to={to}>
      <StyledPartImage src={gfx} alt="" />
      <StyledPartContent>
        <StyledPart>Del {part}</StyledPart>
        <StyledName>{name}</StyledName>
        <OrderedList>
          {chapters.map((item, index) => {
            return (
              <li key={item.key}>
                <Go to={`/bok/${bookId}/kapittel/${item.slug}`}>
                  <span className="chapter-counter">{index + 1}.</span>
                  <span>{item.name}</span>
                </Go>
              </li>
            );
          })}
        </OrderedList>
        {progressStarted ? (
          <ProgressBar progress={progress} />
        ) : (
          <StyledEstimated>
            Estimert tidsbruk:{' '}
            <StyledHours>
              {calcedEstimatedTime}{' '}
              {calcedEstimatedTime === 1 ? 'minutt' : 'minutter'}
            </StyledHours>
          </StyledEstimated>
        )}
      </StyledPartContent>
    </StyledPartCard>
  );
};

ChapterPartCard.propTypes = {
  bookId: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  gfx: PropTypes.string.isRequired,
  part: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  progress: PropTypes.number.isRequired,
  chapters: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.number.isRequired,
      slug: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      estimatedTime: PropTypes.number.isRequired,
      read: PropTypes.bool.isRequired
    })
  )
};

export default ChapterPartCard;



// WEBPACK FOOTER //
// ./src/components/ChapterPartCard.js